import axios from 'axios';
import { handleError } from '@/helpers/HandleError';
import * as general_state from '../store';

const state = {
    
	// Attachments in section list
	faculty_attachments: {},
	
	// Attachments for section
	section_attachments: {},

	// Attachments for question
	question_attachments: {},
};


const getters = {

	// Return Attachments in section list
	faculty_attachments: state => {
		return state.faculty_attachments;
	},

	// Return Attachments for section
	section_attachments: state => {
		return state.section_attachments;
	},

	// Return Attachments for question
	question_attachments: state => {
		return state.question_attachments;
	},
};


const mutations = {	

    // Set Attachments in section list
	set_faculty_attachments: (state, payload) => {
		state.faculty_attachments = payload;
    },
    
	// Set Attachments for section
    set_section_attachments: (state, payload) => {
		state.section_attachments = payload;
    },
	
	// Set Attachments for question
	set_question_attachments: (state, payload) => {
		state.question_attachments = payload;
	},
	
    removeFacultyAttachment: (state, id) => {
        let temp = state.faculty_attachments;
        delete temp[id];
        state.faculty_attachments = {};
        state.faculty_attachments = temp;
    },

    removeSectionAttachment: (state, id) => {
        let temp = state.section_attachments;
        delete temp[id];
        state.section_attachments = {};
        state.section_attachments = temp;
	},

	removeQuestionAttachment: (state, payload) => {
		let temp = state.question_attachments;
		delete temp[payload.id];
		state.question_attachments = {};
		state.question_attachments = temp;
	},
	
	addFacultyAttachment: (state, payload) => {
		let temp = state.faculty_attachments;

		//needed so it wont fore into array
		if(Object.keys(temp).length == 0)
			temp = {};

        temp[payload.id] = payload;
        state.faculty_attachments = {};
        state.faculty_attachments = temp;
	},

	addSectionAttachment: (state, payload) => {
		let temp = state.section_attachments;

		//needed so it wont fore into array
		if(Object.keys(temp).length == 0)
			temp = {};

        temp[payload.id] = payload;
        state.section_attachments = {};
        state.section_attachments = temp;
	},

	addQuestionAttachment: (state, payload) => {
		let temp = state.question_attachments;
		//needed so it wont fore into array
		if(Object.keys(temp).length == 0)
			temp = {};

		temp[payload.id] = payload;
        state.question_attachments = {};
		state.question_attachments = temp;
	},
};


const actions = {
    
	// Get attachments for faculty
	getFacultyAttachments: ({commit}) => {
		commit('showModalWorking');
		axios.post('?module=upload&action=get_faculty_uploads&year='+general_state.state.year+'&faculty='+general_state.state.faculty.id)
		.then(
			res => {
				if(!res.data){				
					var error = res.data.error ? res.data.error : "Napaka";
					commit('hideModalWorking');
					commit('showModal', {component: 'ModalError', data: error})
				}
				else{
					commit('set_faculty_attachments', res.data);
					commit('hideModalWorking');
				}
			}
		)
		.catch(error => handleError(commit, error));		
    },
    
	removeQuestionAttachment: ({ commit }, payload) => {
		commit('decrementAttachmentCount', payload.question_id, { root: true });
		commit('removeQuestionAttachment', payload);
	},

    // Upload attachment for faculty
	uploadFacultyAttachment: ({commit}, payload) => {
        commit('showModalWorking');

        let formData = new FormData();
        formData.append('file', payload.file);
        formData.set('name', payload.file_name);

		axios.post('?module=upload&action=upload_faculty_file&year='+general_state.state.year+'&faculty='+general_state.state.faculty.id+'&tab='+payload.tab, formData)
			.then(
				res => {
					if(!res.data.success){				
                        var error = res.data.error ? res.data.error : formData;
                        commit('hideModalWorking');
						commit('showModal', {component: 'ModalError', data: error})
					}
					else{
						//create upload time string
						let now = new Date();
						let stringNow = now.getFullYear() +'-'+ (now.getMonth()+1) +'-'+ now.getDate() +' '+ now.getHours() +':'+ now.getMinutes() + ':' + now.getSeconds();
						
						//create new upload object
						let new_upload = {id: res.data.upload_id, faculty_id: general_state.state.faculty.id, year: general_state.state.year, 
							name: payload.file_name, url: res.data.upload_url, file_name: payload.file.name, upload_time: stringNow, tab: payload.tab};

						commit('addFacultyAttachment', new_upload);
                        commit('hideModalWorking');
					}
				}
			)
            .catch(error => handleError(commit, error));	
    },
    
    // Delete attachment
	deleteAttachment: ({commit, dispatch}, payload) => {
        commit('showModalWorking');
		axios.post('?module=upload&action=delete_upload&upload_id='+payload.id+'&type='+payload.type, payload)
			.then(
				res => {
					if(!res.data.success){				
                        var error = res.data.error ? res.data.error : formData;
                        commit('hideModalWorking');
						commit('showModal', {component: 'ModalError', data: error})
					}
					else{
                        if(payload.type == 1)
                            commit('removeFacultyAttachment', payload.id);
                        else if(payload.type == 2)
							commit('removeSectionAttachment', payload.id);
						else if(payload.type == 4)
                            dispatch('removeQuestionAttachment', {id:payload.id, question_id:payload.question_id});

                        commit('hideModalWorking');
					}
				}
			)
            .catch(error => handleError(commit, error));	
    },
    
    // Get attachments for section
	getSectionAttachments: ({commit}, payload) => {
		commit('showModalWorking');
		axios.post('?module=upload&action=get_section_uploads&section_id='+payload.section_id+'&faculty='+general_state.state.faculty.id)
		.then(
			res => {
				if(!res.data){				
					var error = res.data.error ? res.data.error : "Napaka";
					commit('hideModalWorking');
					commit('showModal', {component: 'ModalError', data: error})
				}
				else{
					commit('set_section_attachments', res.data);
					commit('hideModalWorking');
				}
			}
		)
		.catch(error => handleError(commit, error));		
    },
    

    // Upload attachment for section
	uploadSectionAttachment: ({commit}, payload) => {
        commit('showModalWorking');

        let formData = new FormData();
        formData.append('file', payload.file);
        formData.set('name', payload.file_name);

		axios.post('?module=upload&action=upload_sections_file&section_id='+payload.section_id+'&faculty='+general_state.state.faculty.id, formData)
			.then(
				res => {
					if(!res.data.success){				
                        var error = res.data.error ? res.data.error : res.data;
                        commit('hideModalWorking');
						commit('showModal', {component: 'ModalError', data: error})
					}
					else{
						//create upload time string
						let now = new Date();
						let stringNow = now.getFullYear() +'-'+ (now.getMonth()+1) +'-'+ now.getDate() +' '+ now.getHours() +':'+ now.getMinutes() + ':' + now.getSeconds();
						
						//create new upload object
						let new_upload = {id: res.data.upload_id, faculty_id: general_state.state.faculty.id, year: general_state.state.year, 
							name: payload.file_name, url: res.data.upload_url, file_name: payload.file.name, upload_time: stringNow};
							
						commit('addSectionAttachment', new_upload);

                        commit('hideModalWorking');
					}
				}
			)
            .catch(error => handleError(commit, error));	
	},

	// Get attachments for question
	getQuestionAttachments: ({commit}, payload) => {
		commit('showModalWorking');
		axios.post('?module=upload&action=get_evalvation_question_uploads&question_id='+payload.question_id+'&program_id='+payload.program_id)
		.then(
			res => {
				if(!res.data){	
					var error = res.data.error ? res.data.error : "Napaka";
					commit('hideModalWorking');
					commit('showModal', {component: 'ModalError', data: error})
				}
				else{
					commit('set_question_attachments', res.data);
					commit('hideModalWorking');
				}
			}
		)
		.catch(error => handleError(commit, error));		
	},

	// Upload attachment for section
	uploadQuestionAttachment: ({commit}, payload) => {
		commit('showModalWorking');

		let formData = new FormData();
		formData.append('file', payload.file);
		formData.set('name', payload.file_name);
		formData.set('additional_programs', JSON.stringify(payload.additional_programs));

		axios.post('?module=upload&action=upload_evalvation_question_file&question_id='+payload.question_id+'&program_id='+payload.program_id, formData)
			.then(
				res => {
					if(!res.data.success){				
						var error = res.data.error ? res.data.error : res.data;
						commit('hideModalWorking');
						commit('showModal', {component: 'ModalError', data: error})
					}
					else{
						//create upload time string
						let now = new Date();
						let stringNow = now.getFullYear() +'-'+ (now.getMonth()+1) +'-'+ now.getDate() +' '+ now.getHours() +':'+ now.getMinutes() + ':' + now.getSeconds();
						
						//create new upload object
						let new_upload = {id: res.data.upload_id, faculty_id: general_state.state.faculty.id, year: general_state.state.year, 
							name: payload.file_name, url: res.data.upload_url, file_name: payload.file.name, upload_time: stringNow, question_id: payload.question_id};

						commit('addQuestionAttachment', new_upload);
						commit('incrementAttachmentCount', payload.question_id, { root: true });

						commit('hideModalWorking');
					}
				}
			)
			.catch(error => handleError(commit, error));	
	},

	downloadAllUploadsProgram: ({commit, dispatch}, payload) => {
		commit('showModalWorking');
		axios.post('?module=upload&action=get_evalvation_program_uploads', payload)
		.then(
			res => {
				if(!res.data.success){	
					var error = res.data.error ? res.data.error : "Napaka";
					commit('hideModalWorking');
					if(error == "no_files"){
						commit('showModal', {component: 'ModalWarning', 
						data: {title:"Ni datotek", description:"Za ta program še ni naloženih datotek"}})
					}
					else if(error == "too_big"){
						commit('showModal', {component: 'ModalWarning', 
						data: {title:"Prenos prevelik", description:"Omejitev prenosa datoteke je 114MB. Poskusite ponovno s prenosom manjših/razdeljenih paketov."}})
					}
					else
						commit('showModal', {component: 'ModalError', data: error})
				}
				else{
					commit('hideModalWorking');
					dispatch('downloadFile', {url:res.data.download_link, filename:'priponke.zip'});
				}
			}
		)
		.catch(error => handleError(commit, error));		
	},

};


export default{
	state,
	getters,
	actions,
	mutations	
}